export default __webpack_public_path__ + "static/media/DYNAMICS365 REMOTE ASSIST.05064b3d.png";